// src/components/ProtectedLink.js
import { useAuth } from "../services/AuthContext";
import { useNavigate } from "react-router-dom";

export default function ProtectedLink({ to, children, className, style }) {
  const { user } = useAuth();
  const navigate = useNavigate();

  const handleClick = (e) => {
    e.preventDefault();

    if (!user) {
      navigate("/login");
    } else {
      navigate(to);
    }
  };

  return (
    <div onClick={handleClick} className={className} style={style}>
      {children}
    </div>
  );
}
